module.exports = __webpack_public_path__ + "static/media/user-cowboy.d67f5a7b.svg";